import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MgIconModule } from '@app/src/app/icon';
import { ManagerOverlayModule } from '@app/src/app/shared/components/manager-overlay';

import { HallpassManagerComponent } from './hallpass-manager.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgIconModule,
    ManagerOverlayModule,

    // External dependencies
    CommonModule,
    RouterModule,
  ],
  declarations: [HallpassManagerComponent],
  exports: [HallpassManagerComponent],
})
export class HallpassManagerModule {}
